let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2YGYU"), load("cGtlr"), load("k9ktU")]).then(() => parcelRequire('iFaMg'));